/**
 * Tenants Module Routes
 *
 * Route definitions for the Tenants module.
 * All routes are relative to the module path (/tenants).
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/tenants',
        component: ModuleLayout,
        meta: {
        },
        children: [
            {
                path: '',
                name: 'tenants-list',
                component: () => import('./views/TenantList.vue'),
                meta: {
                    title: 'All Tenants',
                },
            },
            {
                path: ':id',
                name: 'tenants-detail',
                component: () => import('./views/TenantDetail.vue'),
                meta: {
                    title: 'Tenant Details',
                },
            },
        ],
    },
]

export default routes
